(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.preventReveal = false;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {
        top: 0,
        bottom: this.header.offsetHeight
      };

      this.currentScrollTop = 0;

      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScroll,
        false
      );

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScroll
      );
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        if (entries.length) {
          this.headerBounds = entries[0].intersectionRect;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.headerIsAlwaysSticky) {
          requestAnimationFrame(
            this.hide.bind(this)
          );
        }
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (
          !this.preventReveal &&
          !this.headerIsAlwaysSticky
        ) {
          requestAnimationFrame(
            this.reveal.bind(this)
          );
        } else if (this.preventReveal) {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
          }, 66);
        }
      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.header.classList.remove(
          'scrolled-past-header'
        );

        if (!this.headerIsAlwaysSticky) {
          requestAnimationFrame(
            this.reset.bind(this)
          );
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeCustomMenu();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeCustomMenu() {
      const detailsItems =
        this.header.querySelectorAll(
          '.mv-menu-details[open]'
        );

      detailsItems.forEach((details) => {
        details.removeAttribute('open');
      });

      document.documentElement.classList.remove(
        'mv-header-menu-open'
      );

      document.body.classList.remove(
        'mv-header-menu-open'
      );
    }

    closeSearchModal() {
      const searchModals =
        this.header.querySelectorAll(
          'details-modal'
        );

      searchModals.forEach((modal) => {
        if (
          modal &&
          typeof modal.close === 'function'
        ) {
          modal.close(false);
        }
      });
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }

  function initMonvazaHeaderMenu() {
    const header =
      document.querySelector(
        '.section-header .header'
      );

    if (!header) return;

    if (
      header.dataset.mvMenuReady === 'true'
    ) {
      return;
    }

    header.dataset.mvMenuReady = 'true';

    const detailsItems = Array.from(
      header.querySelectorAll(
        '[data-mv-menu-details]'
      )
    );
    const hoverQuery = window.matchMedia(
      '(min-width: 990px) and (hover: hover) and (pointer: fine)'
    );
    const hoverEnabled =
      header.dataset.mvHoverEnabled === 'true';
    let closeTimer;

    if (!detailsItems.length) return;

    function updateMenuGeometry() {
      const wrapper =
        document.querySelector(
          '.section-header .header-wrapper'
        );

      if (!wrapper) return;

      const rect =
        wrapper.getBoundingClientRect();

      const menuTop = Math.max(
        0,
        Math.min(window.innerHeight, rect.bottom)
      );

      document.documentElement.style.setProperty(
        '--mv-menu-top',
        `${menuTop}px`
      );
    }

    function closeAll(except) {
      detailsItems.forEach((details) => {
        if (
          details !== except &&
          details.hasAttribute('open')
        ) {
          details.removeAttribute('open');
        }
      });
    }

    function cancelHoverClose() {
      window.clearTimeout(closeTimer);
    }

    function openFromHover(details) {
      if (!hoverEnabled || !hoverQuery.matches) return;

      cancelHoverClose();
      closeAll(details);
      details.setAttribute('open', '');
      syncOpenState();
    }

    function closeFromHover(details) {
      if (!hoverEnabled || !hoverQuery.matches) return;

      cancelHoverClose();
      closeTimer = window.setTimeout(() => {
        details.removeAttribute('open');
        syncOpenState();
      }, 140);
    }

    function syncOpenState() {
      const open =
        detailsItems.some((details) =>
          details.hasAttribute('open')
        );

      document.documentElement.classList.toggle(
        'mv-header-menu-open',
        open
      );

      document.body.classList.toggle(
        'mv-header-menu-open',
        open
      );

      if (open) {
        updateMenuGeometry();
      }
    }

    detailsItems.forEach((details) => {
      const summary = details.querySelector('summary');
      const menuPanel = details.querySelector('.mv-menu-panel');

      details.addEventListener(
        'toggle',
        function () {
          if (
            details.hasAttribute('open')
          ) {
            closeAll(details);
          }

          syncOpenState();
        }
      );

      if (summary) {
        summary.addEventListener(
          'pointerenter',
          function () {
            openFromHover(details);
          }
        );
      }

      if (menuPanel) {
        menuPanel.addEventListener(
          'pointerenter',
          cancelHoverClose
        );

        menuPanel.addEventListener(
          'pointerleave',
          function (event) {
            if (summary && summary.contains(event.relatedTarget)) return;
            closeFromHover(details);
          }
        );
      }

      const closeButton =
        details.querySelector(
          '[data-mv-menu-close]'
        );

      if (closeButton) {
        closeButton.addEventListener(
          'click',
          function () {
            details.removeAttribute('open');
            syncOpenState();
          }
        );
      }
    });

    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape') return;

        closeAll(null);
        syncOpenState();
      }
    );

    window.addEventListener(
      'resize',
      updateMenuGeometry,
      { passive: true }
    );

    header.querySelectorAll('.mv-header-nav__item').forEach((item) => {
      if (item.querySelector('[data-mv-menu-details]')) return;

      item.addEventListener('pointerenter', function () {
        if (!hoverEnabled || !hoverQuery.matches) return;

        cancelHoverClose();
        closeAll(null);
        syncOpenState();
      });
    });

    updateMenuGeometry();
  }

  function initMonvazaMobileDrawer() {
    if (typeof window.mvMobileDrawerCleanup === 'function') {
      window.mvMobileDrawerCleanup();
    }

    const drawer = document.querySelector(
      '.section-header header-drawer'
    );
    const details = drawer?.querySelector(
      ':scope > details'
    );
    const summary = details?.querySelector(
      ':scope > summary'
    );
    const menuPanel = details?.querySelector(
      '.menu-drawer'
    );

    if (!drawer || !details || !summary || !menuPanel) return;

    let lockedScrollY = 0;
    let pendingScrollY = window.scrollY;
    let isLocked = false;

    function captureScrollPosition() {
      if (!details.hasAttribute('open')) {
        pendingScrollY = window.scrollY;
      }
    }

    function preventBackgroundTouch(event) {
      if (!menuPanel.contains(event.target)) {
        event.preventDefault();
      }
    }

    function preventBackgroundWheel(event) {
      if (!menuPanel.contains(event.target)) {
        event.preventDefault();
      }
    }

    function lockPage() {
      if (
        isLocked ||
        window.innerWidth > 989 ||
        !details.hasAttribute('open')
      ) {
        return;
      }

      lockedScrollY = pendingScrollY;
      isLocked = true;

      document.documentElement.classList.add(
        'mv-mobile-menu-open'
      );
      document.body.classList.add(
        'mv-mobile-menu-open'
      );
      document.addEventListener(
        'touchmove',
        preventBackgroundTouch,
        { passive: false }
      );
      document.addEventListener(
        'wheel',
        preventBackgroundWheel,
        { passive: false }
      );
    }

    function unlockPage() {
      if (!isLocked) return;

      isLocked = false;

      document.documentElement.classList.remove(
        'mv-mobile-menu-open'
      );
      document.body.classList.remove(
        'mv-mobile-menu-open'
      );
      document.removeEventListener(
        'touchmove',
        preventBackgroundTouch
      );
      document.removeEventListener(
        'wheel',
        preventBackgroundWheel
      );
      window.scrollTo(0, lockedScrollY);
    }

    function syncMobileDrawerState() {
      if (
        details.hasAttribute('open') &&
        window.innerWidth <= 989
      ) {
        window.requestAnimationFrame(lockPage);
      } else {
        unlockPage();
      }
    }

    function handleResize() {
      if (window.innerWidth > 989) {
        unlockPage();
        return;
      }

      syncMobileDrawerState();
    }

    details.addEventListener(
      'toggle',
      syncMobileDrawerState
    );
    summary.addEventListener(
      'click',
      captureScrollPosition,
      true
    );
    window.addEventListener(
      'resize',
      handleResize,
      { passive: true }
    );

    window.mvMobileDrawerCleanup = function () {
      details.removeEventListener(
        'toggle',
        syncMobileDrawerState
      );
      summary.removeEventListener(
        'click',
        captureScrollPosition,
        true
      );
      window.removeEventListener(
        'resize',
        handleResize
      );
      unlockPage();
      window.mvMobileDrawerCleanup = null;
    };

    syncMobileDrawerState();
  }

  initMonvazaHeaderMenu();
  initMonvazaMobileDrawer();

  document.addEventListener(
    'shopify:section:load',
    function () {
      initMonvazaHeaderMenu();
      initMonvazaMobileDrawer();
    }
  );

  } catch(e) { console.error(e); }
})();
})();
